import React from "react";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    ChartOptions,
} from "chart.js";
import { Pie } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

ChartJS.register(ArcElement, Tooltip, Legend);

export const options: ChartOptions<"pie"> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: { display: false },
        tooltip: { enabled: false },
    },
    layout: { padding: 3 },
};

interface PieChartProps {
    cached_tokens: number;
    input_tokens: number;
    output_tokens: number;
}

export const PieChart: React.FC<PieChartProps> = ({cached_tokens, input_tokens, output_tokens}) => {
    const { t } = useTranslation();

    const total = cached_tokens + input_tokens + output_tokens;
    const toPercent = (value: number) => ((value / total) * 100).toFixed(1);

    const data = {
        //@ts-ignore
        labels: [t("tokenHistory.inputTokens"), t("tokenHistory.outputTokens"), t("tokenHistory.cachedTokens"),],
        datasets: [
            {
                data: [
                    Number(toPercent(input_tokens)),
                    Number(toPercent(output_tokens)),
                    Number(toPercent(cached_tokens)),
                ],
                backgroundColor: ["#4C9EFF", "#1E5AA8", "#BFCDE0"],
                borderWidth: 0,
                cutout: "35%",
            },
        ],
    };

    const labels = data.labels;
    const values = data.datasets[0].data;
    const colors = data.datasets[0].backgroundColor as string[];

    return (
        <div className="flex flex-row-reverse items-center justify-between w-full">
            <div className="flex flex-1 justify-end">
                <div className="w-[140px] md:w-[180px] h-[165px]">
                    <Pie data={data} options={options} />
                </div>
            </div>
            <div className="flex flex-col gap-[11px] text-right rtl">
                {labels.map((label, i) => (
                    <div key={i} className="flex items-center gap-2 ">
                        <div className="flex flex-col leading-[1.3] w-full">
              <span className="text-[18px] font-bold text-[#222] mb-[2px] text-end">
                {values[i]}٪
              </span>
                            <div className="flex items-center">
                <span
                    className="inline-block rounded-full"
                    style={{
                        width: "8px",
                        height: "8px",
                        backgroundColor: colors[i],
                    }}
                ></span>
                                <span className="ms-2 text-[13px] text-[#666]">{label}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
